import request from "./request"

// 安全接口均要求登录；“当前邮箱”始终由服务端会话确定，前端不能自行指定。
export const getSecurityOverview = () => request({ url: "/security/overview_get", method: "get" })
export const getSecurityDevices = () => request({ url: "/security/device_list_get", method: "get" })
export const getQrLoginRecords = params => request({ url: "/security/qr_login_record_list_get", method: "get", params })
export const revokeSecuritySession = data => request({ url: "/security/session_revoke", method: "post", data })
export const sendSecurityCode = data => request({ url: "/security/code_send", method: "post", data })
export const updateSecurityEmail = data => request({ url: "/security/email_update", method: "post", data })
export const updateSecurityUsername = data => request({ url: "/security/username_update", method: "post", data })
export const updateSecurityPassword = data => request({ url: "/security/password_update", method: "post", data })
